module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#star",
      toString: function () {
        return this.url;
      }
    }